import loadable from '@loadable/component';

export const ViewOfferScreen = loadable(() => import('./index'));
